import './segmented-stepper.scss';

import { cn } from '../../utils/helpers.ts';

type SegmentedStepperProps = {
  count: number;
  activeItem?: number;
  className?: string;
};

export const SegmentedStepper: React.FC<SegmentedStepperProps> = ({
  count,
  activeItem = 0,
  className,
}) => {
  return (
    <div className={`SegmentedStepper flex mx-auto ${className}`}>
      {Array.from({ length: count }).map((_, index) => {
        return (
          <div
            key={index}
            className={cn('SegmentedStepper__item h-full w-full', {
              'SegmentedStepper__item--visited': index < activeItem,
              'SegmentedStepper__item--active': index === activeItem,
              'SegmentedStepper__item--upcoming': index > activeItem,
            })}
          />
        );
      })}
    </div>
  );
};
